import { ViewController, ModelUpdateEvent, PlaybackStopEvent, DataReceiveEvent, MaintenanceEvent,
    VideoReloadEvent, TimeUpdateEvent, ChannelSwitchEvent, PlaybackStartEvent, ButtonClickEvent } from "@gaming/srvg-classes-core";
import { MicroView } from "../../View/AppView/MicroView";
import { TitlebarController } from "./TitlebarController";
import { VideoController } from "./VideoController";
import { MatchdayAreaController } from "./MatchdayAreaController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class MicroViewController extends ViewController {
    microView: MicroView;

    videoController: VideoController;
    matchdayAreaController: MatchdayAreaController;
    titlebarController: TitlebarController;
    videoStatus: string;

    constructor( options ) {
        options = options || {};
        options.view = options.microView || null;
        super( options );
        this.name = 'vblMicroViewController';

        this.microView = options.microView || null;

        /******************* initialize controllers ************************/

        this.videoController = this.addChildViewController( new VideoController( {
            videoView: this.microView.videoView,
            videoControlBar: null,
            channel: srvg.videooptions.defaultchannel
        } ) );

        this.titlebarController       = this.addChildViewController( new TitlebarController( { titlebar: this.microView.titlebar } ) );

        this.matchdayAreaController = this.addChildViewController( new MatchdayAreaController({
            matchdayArea: this.microView.matchdayArea
        }) );

        this.videoStatus = 'stopped';

        /******************* connect components ************************/

        var exch = srvg.eventExchange;

        //___________________eventSubscriber________________eventProvider___________________eventType___________eventHandler_________________
        this.microView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.customerIntegration, ModelUpdateEvent );
        this.microView.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.matchIdsFeedController, ModelUpdateEvent );
        app.matchIdsFeedController.addSubscriberForEvent( app.customerIntegration, DataReceiveEvent  );

        app.timelineController.addSubscriberForEvent( srvg.maintenance,        MaintenanceEvent );
        app.timelineController.addSubscriberForEvent( app.customerIntegration, PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( app.server,              TimeUpdateEvent );
        app.timelineController.addSubscriberForEvent( this.videoController,    VideoReloadEvent );

        app.timelineController.addSubscriberForEvent( this.titlebarController, PhaseChangeEvent );

        var mdac = this.matchdayAreaController;

        exch.addEventHandler(this.videoController,          'all',                         ChannelSwitchEvent );

        this.microView.playButton.addSubscriberForEvent( this, ButtonClickEvent );

        this.microView.videoView.addSubscriberForEvent( this, PlaybackStartEvent );
        this.microView.videoView.addSubscriberForEvent( this, PlaybackStopEvent );
        this.microView.videoView.addSubscriberForEvent( this, ButtonClickEvent );

        /******************* start components ************************/
        app.timelineController.startPolling();
        app.customerIntegration.startCustomerActions();
    }

    handleButtonClickEvent( event:ButtonClickEvent, eventProvider ) {
        //console.log( 'handleButtonClickEvent', eventProvider.name );
        if( eventProvider == this.microView.videoView ) {
            if( this.videoStatus == 'playing' ) {
                this.videoController.videoView.setPaused( true );
                $('#playbutton_container').show();
                this.videoStatus = 'paused';
            }
        }
        else if( eventProvider == this.microView.playButton ) {
            if( this.videoStatus == 'stopped' ) {
                $('#playbutton_container').hide();
                if( this.microView.youtubeVideoView ) {
                    // playerclass playbutton handling
                    $('.playButtonWrapper').addClass('hidden').removeClass('enabled').removeAttr('style');
                    this.microView.youtubeVideoView.hide();
                    if(!srvg.isMobile){
                        this.showPlayButtonPC();
                    }
                }
                $('#youtubevideo_container').hide();
                this.videoController.play();
                this.videoStatus = 'playing';
            }
            else if( this.videoStatus == 'paused' ) {
                this.videoController.videoView.setPaused( false );
                $('#playbutton_container').hide();
                this.videoStatus = 'playing';
            }


        }
    }

    handlePlaybackStartEvent( event:PlaybackStartEvent, provider ) {
        // FIXME doesn't work in chrome
        //this.microView.pauseButton.show();
    }

    handlePlaybackStopEvent( event:PlaybackStopEvent, provider ) {
        // FIXME doesn't work in chrome
        //this.microView.pauseButton.hide();
    }

    showPlayButtonPC(){

        var that = this;
        $('#videoView').on('click', function () {
            srvg.player.api.stop();
            $('.playerclassPoster').addClass('hidden');
            $('.playerclassPoster').removeClass('visible');
            $('#playbutton_container').show();
            setTimeout(()=> {
                $('#playbutton').on('click', () => {
                    setTimeout(() => {
                        that.hidePlayButtonPC()
                    }, 1000);
                })
            },500)

        });
    }


    hidePlayButtonPC(){

        $('#playbutton_container').hide();
        srvg.player.api.play();
        $('#playbutton').off(); // Delete all previously placed event listeners

    }
}